/**
 * Shop Failure Page - Payment failed
 */
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, RefreshCw, Home } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';

const ShopFailure = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <Card className="bg-gray-800 border-gray-700 max-w-md w-full">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto mb-4 w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          <CardTitle className="text-2xl text-white">Pago no completado</CardTitle>
          <CardDescription className="text-gray-400">
            El pago no pudo ser procesado
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="text-center text-gray-400">
            <p className="mb-2">Esto puede ocurrir por varias razones:</p>
            <ul className="text-sm space-y-1">
              <li>• Fondos insuficientes</li>
              <li>• Tarjeta rechazada</li>
              <li>• Sesión expirada</li>
              <li>• Pago cancelado</li>
            </ul>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button
              onClick={() => navigate('/shop')}
              className="w-full bg-[#7ED957] hover:bg-[#6bc548] text-black font-bold"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Intentar de nuevo
            </Button>
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full border-gray-600 text-gray-300 hover:bg-gray-700"
            >
              <Home className="w-4 h-4 mr-2" />
              Volver al inicio
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ShopFailure;
